import {
    PHONE_CHECK_EXP_NAME,
    PHONE_CHECK_STORAGE_NAME,
} from '@/src/modules/checkout/strings'

function determineStoredPhoneInfo() {
    let storedPhones: any[] = []
    let storedExpiration

    try {
        storedPhones = JSON?.parse(
            window?.localStorage?.getItem(PHONE_CHECK_STORAGE_NAME) ?? '[]'
        )
        storedExpiration = window?.localStorage?.getItem(PHONE_CHECK_EXP_NAME)
    } catch (error) {
        console.log('lol Unable to access stored phone data')
    }

    return { storedPhones, storedExpiration }
}

export default determineStoredPhoneInfo
